var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client',{attrs:{"isSuccess":_vm.isSuccess}},[_c('submission-inputs',{on:{"on-success":_vm.onSuccess}}),(_vm.isSuccess)?_c('submission-status'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }